import OadpEntityButtonReadCondition from './oadp-entity-button-read-condition';
export default OadpEntityButtonReadCondition;
